import { createAction, props } from '@ngrx/store';
import {
  Account,
  Dictionary,
  Section,
  SectionDomainSetting,
} from '../../models';

export const getAccountsActions = {
  get: createAction(
    '[Domain Settings Edit] Get Accounts',
    props<{ accountQuery?: string }>(),
  ),
  success: createAction(
    '[Domain Settings Edit] Get Accounts Success',
    props<{ accounts: Account[] }>(),
  ),
  fail: createAction('[Domain Settings Fail] Get Accounts Fail'),
};

export const selectAccountActions = {
  select: createAction(
    '[Domain Settings Edit] Select Account',
    props<{ account?: string }>(),
  ),
  success: createAction(
    '[Domain Settings Edit] Select Account Success',
    props<{ account?: string }>(),
  ),
  get: createAction('[Domain Settings Edit] Get Selected Account'),
};

export const getSectionsActions = {
  get: createAction(
    '[Domain Settings Edit] Get Sections',
    props<{ accountId: string }>(),
  ),
  success: createAction(
    '[Domain Settings Edit] Get Sections Success',
    props<{ sections?: Dictionary<Section> }>(),
  ),
  fail: createAction('[Domain Settings Edit] Get Sections Fail'),
};

export const accountDomainSettingActions = {
  setAccount: createAction(
    '[Domain Settings Edit] Set Account',
    props<{ accountId: string }>(),
  ),
  setAccountSuccess: createAction(
    '[Domain Settings Edit] Set Account Success',
    props<{ accountId }>(),
  ),
  setAccountDomainName: createAction(
    '[Domain Settings Edit] Set Account Domain Name',
    props<{ accountDomainName: string }>(),
  ),
  addAccountDomainSetting: createAction(
    '[Domain Settings Edit] Add Account Domain Setting',
    props<{ accountDomainSetting }>(),
  ),
  toggleDomain: createAction(
    '[Domain Setting Edit] Toggle Domain',
    props<{ enabled: boolean }>(),
  ),
  clear: createAction('[Domain Settings Edit] Clear'),
  cancel: createAction('[Domain Settings Cancel] Cancel'),
  save: createAction('[Domain Settings Edit] Save'),
  saveSuccess: createAction('[Domain Settings Edit] Save Success'),
  saveFail: createAction('[Domain Settings Edit] Save Fail'),
  update: createAction('[Domain Settings Edit] Update'),
  updateSuccess: createAction('[Domain Settings Edit] Update Success'),
  updateFail: createAction('[Domain Settings Edit] Update Fail'),
};

export const sectionDomainActions = {
  addSectionDomain: createAction(
    '[Domain Settings Edit] Add Section Domain',
    props<{ section: SectionDomainSetting }>(),
  ),
  removeSectionDomain: createAction(
    '[Domain Settings Edit] Remove Section Domain',
    props<{ sectionId: string }>(),
  ),
  selectSectionDomain: createAction(
    '[Domain Settings Edit] Select Section Domain',
    props<{ sectionId: string }>(),
  ),
  selectSectionDomainSuccess: createAction(
    '[Domain Settings Edit] Select Section Domain Success',
    props<{ sectionId: string }>(),
  ),
};
